/**
 * GraphQL mutations for expense management operations
 * Requirements: 9.2 - GraphQL mutations support
 */

export const CREATE_EXPENSE = `
  mutation CreateExpense($input: CreateExpenseInput!) {
    createExpense(input: $input) {
      id
      title
      category
      amount
      date
      description
      paymentMethod
      status
      submitterId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_EXPENSE = `
  mutation UpdateExpense($id: ID!, $input: UpdateExpenseInput!) {
    updateExpense(id: $id, input: $input) {
      id
      title
      category
      amount
      date
      description
      paymentMethod
      status
      submitterId
      createdAt
      updatedAt
    }
  }
`;

export const SUBMIT_EXPENSE = `
  mutation SubmitExpense($id: ID!) {
    submitExpense(id: $id) {
      id
      status
      updatedAt
      approvals {
        id
        approverId
        status
        level
        timestamp
      }
    }
  }
`;

export const DELETE_EXPENSE = `
  mutation DeleteExpense($id: ID!) {
    deleteExpense(id: $id) {
      success
      message
    }
  }
`;

export const APPROVE_EXPENSE = `
  mutation ApproveExpense($input: ApprovalActionInput!) {
    approveExpense(input: $input) {
      id
      status
      updatedAt
      approvals {
        id
        approverId
        status
        comments
        level
        timestamp
      }
    }
  }
`;

export const REJECT_EXPENSE = `
  mutation RejectExpense($input: ApprovalActionInput!) {
    rejectExpense(input: $input) {
      id
      status
      updatedAt
      approvals {
        id
        approverId
        status
        comments
        level
        timestamp
      }
    }
  }
`;

export const MARK_REIMBURSED = `
  mutation MarkReimbursed($id: ID!) {
    markReimbursed(id: $id) {
      id
      status
      updatedAt
    }
  }
`;

export const UPLOAD_RECEIPT = `
  mutation UploadReceipt($input: ReceiptUploadInput!) {
    uploadReceipt(input: $input) {
      id
      expenseId
      fileName
      fileUrl
      fileType
      fileSize
      uploadedAt
    }
  }
`;

export const DELETE_RECEIPT = `
  mutation DeleteReceipt($id: ID!) {
    deleteReceipt(id: $id) {
      success
      message
    }
  }
`;

export const CREATE_CATEGORY = `
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      id
      name
      description
      isActive
      maxAmount
      requiresReceipt
    }
  }
`;

export const UPDATE_CATEGORY = `
  mutation UpdateCategory($id: ID!, $input: CategoryInput!) {
    updateCategory(id: $id, input: $input) {
      id
      name
      description
      isActive
      limits {
        maxAmount
        requiresReceipt
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CATEGORY = `
  mutation DeleteCategory($id: ID!) {
    deleteCategory(id: $id) {
      success
      message
    }
  }
`;

export const SEND_NOTIFICATION = `
  mutation SendNotification($input: NotificationInput!) {
    sendNotification(input: $input) {
      success
      messageId
      error
    }
  }
`;

export const CREATE_APP_SETTING = `
  mutation CreateAppSetting($input: CreateAppSettingInput!) {
    createAppSetting(input: $input) {
      id
      value
      updatedAt
      updatedBy
    }
  }
`;

export const UPDATE_APP_SETTING = `
  mutation UpdateAppSetting($input: UpdateAppSettingInput!) {
    updateAppSetting(input: $input) {
      id
      value
      updatedAt
      updatedBy
    }
  }
`;
